export default __webpack_public_path__ + "static/media/jesus-crusificado-3.d8cc6060.png";